import { Text } from "@gcs/design-system/react";
import styled from "styled-components/macro";

export const TextBlock = styled(Text)(({ theme, isPrimaryColor }) => ({
  padding: "0 20px",
  backgroundColor: isPrimaryColor
    ? theme.color.brandPrimary.light
    : theme.color.brandSecondary.light,

  [theme.breakpoint.md()]: {
    padding: "0px 65px",
    fontSize: "48px",
  },
}));
